module.exports = __webpack_public_path__ + "img/d20060424b.37bc0736.jpg";